import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '24 7.8'
  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M2.21987 2.90008C3.52987 0.0100847 19.6499 2.46008 20.9799 5.90008C22.3099 9.34009 19.9799 15.6701 10.4299 14.1101C0.889896 12.5501 1.10987 5.34008 2.21987 2.90008Z"
        stroke="#644534"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M45.6997 2.90008C44.3897 0.0100847 28.2697 2.46008 26.9397 5.90008C25.6097 9.34009 27.9397 15.6701 37.4897 14.1101C47.0297 12.5501 46.8097 5.34008 45.6997 2.90008Z"
        stroke="#644534"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path d="M20.8999 5.65015H27.0199" stroke="#644534" strokeWidth="1.5" strokeMiterlimit="10" />
    </g>
  )
}
